import { Box, Grid, Typography } from "@mui/material"
import AppDatePicker from "components/AppDatePicker"
import ImageUploadField from "components/FileUpload/ImageUploadField"
import ImageCropper from "components/ImageCropper"
import AppTextField from "components/StyledComponents/AppTextField"
import StyledLabel from "components/StyledComponents/StyledLabel"
import { capitalize, handleTimeChange } from "helpers/functions"
import React, { useRef, useState } from "react"
import UploadPdfField from "../UploadPdfField"
import WeeklySchedule from "../WeeklySchedule"
import ImageUploadWithPreview from "components/FileUploadWithPreview/ImageUploadPreview"
import { Col, Row } from "react-bootstrap"
import { useDispatch, useSelector } from "react-redux"
import { uploadImageAction } from "redux/hotel/action"
import { hotelAction } from "redux/hotel/slice/user"
import { generateSoundbitesAction } from "redux/marketing/actions"
import AppTextArea from "components/StyledComponents/AppTextArea"
import { Pause, PlayArrow } from "@mui/icons-material"
import AppButton from "components/StyledComponents/AppButton"
import DidYouKnowFormHotel from "../FieldsModal/DidYouKnow"
import HistoryFormHotel from "../FieldsModal/History"

const NormalSteps = ({ data, formik, type, activeStep }) => {
  const dispatch = useDispatch()
  const [uploadType, setUploadType] = useState("")
  const [openCrop, setCrop] = useState(false)
  const [fileDetails, setFileDetails] = useState(null)
  const [imageObjectURL, setImageObjectUrl] = useState(null)
  const [selectedFieldPath, setSelectedFieldPath] = useState(null)
  const [imageKey, setImageKey] = useState("")
  const [sectionKey, setSectionKey] = useState("")
  const [isPlaying, setIsPlaying] = useState(false)
  const audioRef = useRef(null)
  const { soundbites } = useSelector((state) => state.marketing)

  const onImageUpload = (image, fieldPath, key, sectionKey) => {
    setUploadType("image")
    setSelectedFieldPath(fieldPath)
    setImageKey(key)
    setSectionKey(sectionKey)
    setCrop(true)
    setFileDetails(image)
    setImageObjectUrl(URL.createObjectURL(image))
  }

  function handleCroppedImage(image, formik) {
    if (uploadType === "image" && selectedFieldPath) {
      let data = new FormData()
      data.append("media", image)
      data.append("media_type", "IMAGE")
      data.append("content_type", image.type)

      formik.setFieldValue(selectedFieldPath, image)
      dispatch(uploadImageAction({ data, fieldKey: imageKey, sectionKey: sectionKey }))
      setUploadType("")
    }
  }

  function showCropperModal(imageObjectURL, fileDetails, formik) {
    return (
      <ImageCropper
        setSelectedImage={(image) => handleCroppedImage(image, formik)}
        srcImage={imageObjectURL}
        fileDetail={fileDetails}
        aspectRatio={uploadType === "uploadThumbnail" && 1}
        onClose={setCrop}
        openCrop={openCrop}></ImageCropper>
    )
  }
  const handleImageDelete = (formik, fieldPath, key, sectionKey) => {
    dispatch(hotelAction.removeImageId({ key, sectionKey }))
    formik.setFieldValue(fieldPath, null)
  }

  const handleSoundbite = (soundbite) => {
    const payload = {
      text: soundbite,
      voice_id: formik.values?.soundbite_voice_id
    }
    dispatch(generateSoundbitesAction(payload))
    formik.setFieldTouched(`soundbite`, false)
  }

  const toggleSoundbite = () => {
    const soundbite_url = soundbites?.url || formik.values?.soundbite_url

    if (!soundbite_url) return

    // If already playing, pause it
    if (isPlaying && audioRef.current) {
      audioRef.current.pause()
      setIsPlaying(false)
    } else {
      // If audio exists, reset it
      if (audioRef.current) {
        audioRef.current.pause()
        audioRef.current.currentTime = 0
      }

      // Create new audio and play
      audioRef.current = new Audio(soundbite_url)
      audioRef.current.play()
      setIsPlaying(true)

      // When audio ends, reset state
      audioRef.current.onended = () => {
        setIsPlaying(false)
      }
    }
  }
  const getComponentType = (label, SectionType, type) => {
    if (type === "price") return

    if (SectionType === "week_time_range") {
      return "weeklySchedule"
    }
    switch (label) {
      case "text":
        return "textField"
      case "image":
      case "images":
        return "imageUpload"
      case "file":
        return "uploadPdf"
      case "multiple_image":
        return "restaurantImageUpload"
      default:
        return "textField"
    }
  }

  return (
    <React.Fragment>
      {showCropperModal(imageObjectURL, fileDetails, formik)}
      <Box flexDirection="column" className="mt-4 w-100">
        {data?.map((field, index) => (
          <Box key={index} className="mb-4">
            {!!field.fields?.length && (
              <Grid container alignItems="center" className="mb-3">
                <Typography variant="h2" style={{ marginRight: "16px", whiteSpace: "nowrap" }}>
                  {field.label}
                </Typography>
                <div
                  style={{
                    flexGrow: 1,
                    height: "1px",
                    backgroundColor: "#E0E0E0"
                  }}
                />
              </Grid>
            )}
            {field?.fields.map((item, fieldIndex) => {
              const componentType = getComponentType(item?.type, field?.type, item?.key)
              const fieldPath = `${type}.${field.key}.${item.key}`

              switch (componentType) {
                case "textField":
                  return (
                    <Row className="w-100 m-0 mt-4" key={fieldIndex}>
                      <Col lg="12">
                        <AppTextField
                          id={item?.key}
                          name={item?.label}
                          type={item?.key === "price" ? "number" : "text"}
                          fullWidth
                          isRequired={
                            field?.key === "common" &&
                            (item?.key === "name" || item?.key === "description")
                          }
                          label={capitalize(item?.label)}
                          isUpperCase={!false}
                          placeholder={`Enter ${item?.label}`}
                          value={formik?.values?.[type]?.[field?.key]?.[item?.key]}
                          onBlur={formik?.handleBlur(fieldPath)}
                          onChange={formik?.handleChange(fieldPath)}
                          error={
                            formik.touched?.[type]?.[field?.key]?.[item.key] &&
                            Boolean(formik.errors?.[type]?.[field?.key]?.[item.key])
                          }
                          touched={formik.touched?.[type]?.[field?.key]?.[item.key]}
                          helperText={
                            formik.touched?.[type]?.[field?.key]?.[item.key] &&
                            formik.errors?.[type]?.[field?.key]?.[item.key]
                          }
                        />
                      </Col>
                    </Row>
                  )
                case "imageUpload":
                  return (
                    <Row className="w-100 m-0 mt-4" key={fieldIndex}>
                      <Col lg="12">
                        <ImageUploadField
                          id={item?.key}
                          label={item?.label}
                          isVariant={true}
                          placeholder={`Upload ${item?.label}`}
                          value={formik?.values?.[type]?.[field?.key]?.[item?.key]}
                          onChange={(e) => onImageUpload(e, fieldPath, item?.key, field?.key)}
                          onDelete={() =>
                            handleImageDelete(formik, fieldPath, item?.key, field?.key)
                          }
                          error={formik.errors?.[type]?.[field?.key]?.[item.key]}
                          touched={formik.touched?.[type]?.[field?.key]?.[item.key]}
                        />
                      </Col>
                    </Row>
                  )

                case "numberField":
                  return (
                    <Row className="w-100 m-0 mt-4" key={fieldIndex}>
                      <Col lg="12">
                        <AppTextField
                          id={item?.label}
                          name={`${type}.${item?.label}`}
                          type="number"
                          fullWidth
                          label={item?.label}
                          isUpperCase={!false}
                          placeholder={`Enter ${item?.label}`}
                          value={formik?.values?.[type]?.[field?.key]?.[item?.key]}
                          onChange={formik?.handleChange(fieldPath)}
                          onBlur={formik?.handleBlur(fieldPath)}
                          error={
                            formik.touched?.[type]?.[field?.key]?.[item.key] &&
                            Boolean(formik.errors?.[type]?.[field?.key]?.[item.key])
                          }
                          touched={formik.touched?.[type]?.[field?.key]?.[item.key]}
                          helperText={
                            formik.touched?.[type]?.[field?.key]?.[item.key] &&
                            formik.errors?.[type]?.[field?.key]?.[item.key]
                          }
                        />
                      </Col>
                    </Row>
                  )
                case "datePicker":
                  return (
                    <Grid item xs={12} className="datesContainer">
                      <StyledLabel variant="body1Regular">{item?.label}</StyledLabel>
                      <Box className="dateFieldContainer w-100 mt-2">
                        <AppDatePicker
                          minDate={new Date()}
                          maxDate={new Date().setMonth(new Date().getMonth() + 5)}
                          inputFormat="dd MMM yyyy"
                          value={formik?.values?.[type]?.[field?.key]?.[item?.key]}
                          onChange={(val) => formik?.setFieldValue(`${type}.${item?.label}`, val)}
                          error={formik.errors?.[type]?.[field?.key]?.[item.key]}
                          touched={formik.touched?.[type]?.[field?.key]?.[item.key]}
                        />
                      </Box>
                    </Grid>
                  )
                case "timeField":
                  return (
                    <Grid item xs={12} key={index}>
                      <AppTextField
                        id={item?.label}
                        type="time"
                        fullWidth
                        label={item?.label}
                        isUpperCase={true}
                        value={formik?.values?.[type]?.[field?.key]?.[item?.key]}
                        onChange={(e) => handleTimeChange(e, `${type}.${item?.label}`, formik)}
                        error={
                          formik.touched?.[type]?.[field?.key]?.[item.key] &&
                          Boolean(formik.errors?.[type]?.[field?.key]?.[item.key])
                        }
                        touched={formik.touched?.[type]?.[field?.key]?.[item.key]}
                        helperText={
                          formik.touched?.[type]?.[field?.key]?.[item.key] &&
                          formik.errors?.[type]?.[field?.key]?.[item.key]
                        }
                      />
                    </Grid>
                  )
                case "restaurantImageUpload":
                  return (
                    <Row className="w-100 m-0 mt-4" key={fieldIndex}>
                      <Col lg="12">
                        <ImageUploadWithPreview
                          label={item?.label}
                          isVariant={true}
                          placeholder="Upload Image"
                          value={formik?.values?.[type]?.[field?.key]?.[item?.key]}
                          onChange={(e) => onImageUpload(e, fieldPath)}
                          onDelete={() => handleImageDelete(formik)}
                        />
                      </Col>
                    </Row>
                  )
                case "uploadPdf":
                  return (
                    <Row className="w-100 m-0 mt-4" key={fieldIndex}>
                      <Col lg="12">
                        <UploadPdfField
                          title={item?.label}
                          placeholder={`Upload ${item?.label}`}
                          label={item?.label}
                          formik={formik}
                          type={type}
                          fieldPath={fieldPath}
                        />
                      </Col>
                    </Row>
                  )

                default:
                  return null
              }
            })}
            {field?.type === "week_time_range" && (
              <Row className="w-100 m-0 mt-4" key={index}>
                <Col lg="12">
                  <WeeklySchedule
                    formik={formik}
                    label={field?.key}
                    type="fields"
                    title="Weekly Schedule"
                  />
                </Col>
              </Row>
            )}
          </Box>
        ))}
        {activeStep === 0 && (
          <>
            <Grid container alignItems="center" className="mb-3 mt-4">
              <Typography variant="h2" style={{ marginRight: "16px", whiteSpace: "nowrap" }}>
                Soundbite
              </Typography>
              <div
                style={{
                  flexGrow: 1,
                  height: "1px",
                  backgroundColor: "#E0E0E0"
                }}
              />
            </Grid>
            <Row className="w-100 m-0 mt-4">
              <Col lg="12">
                <AppTextArea
                  label="Soundbite"
                  minRows={5}
                  maxRows={15}
                  placeholder={`Enter Soundbite`}
                  value={formik.values?.soundbite}
                  onChange={formik.handleChange("soundbite")}
                  onBlur={formik.handleBlur("soundbite")}
                  error={Boolean(formik.errors?.soundbite)}
                  touched={formik.touched?.soundbite}
                  helperText={formik.errors?.soundbite}
                />
              </Col>
              <Row
                className="w-100 m-0 mt-2 mb-2  align-items-center"
                style={{ justifyContent: "space-between" }}>
                <Col lg="4" className="p-0">
                  <AppTextField
                    id={"soundbite_voice_id"}
                    type="text"
                    fullWidth
                    label="Soundbite Voice Id"
                    isUpperCase={true}
                    placeholder={`Enter Soundbite Voice Id`}
                    value={formik.values?.soundbite_voice_id}
                    onChange={formik.handleChange("soundbite_voice_id")}
                    onBlur={formik.handleBlur("soundbite_voice_id")}
                    error={Boolean(formik.errors?.soundbite_voice_id)}
                    touched={formik.touched?.soundbite_voice_id}
                    helperText={formik.errors?.soundbite_voice_id}
                  />
                </Col>
                <Col lg="8" className="mt-3">
                  <Row className="w-100 m-0 mt-2 mb-2 justify-content-end align-items-center">
                    <Col lg="3" className="d-flex justify-content-end p-0">
                      {(soundbites?.url || formik.values?.soundbite_url) &&
                        !formik.touched?.soundbite && (
                          <AppButton styles={{ padding: "10px 16px" }} onClick={toggleSoundbite}>
                            {isPlaying ? (
                              <>
                                <Pause sx={{ height: 28, width: 28, marginRight: 1 }} />
                                Stop
                              </>
                            ) : (
                              <>
                                <PlayArrow sx={{ height: 28, width: 28, marginRight: 1 }} />
                                Play
                              </>
                            )}
                          </AppButton>
                        )}
                    </Col>
                    <Col lg="5" className="d-flex justify-content-end p-0">
                      <AppButton
                        sx={{ padding: "13px 16px" }}
                        disabled={!formik.values?.soundbite}
                        onClick={() => handleSoundbite(formik.values?.soundbite)}>
                        Generate Sound Bite
                      </AppButton>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Grid container alignItems="center" className="mt-4">
                <Typography variant="h2" style={{ marginRight: "16px", whiteSpace: "nowrap" }}>
                  Did You know
                </Typography>
                <div
                  style={{
                    flexGrow: 1,
                    height: "1px",
                    backgroundColor: "#E0E0E0"
                  }}
                />
              </Grid>
              <DidYouKnowFormHotel
                formik={formik}
                values={formik.values?.["did_you_know"]}
                name={"did_you_know"}
                buttonText={"Add Did you know"}
              />
              <Grid container alignItems="center" className="mt-4">
                <Typography variant="h2" style={{ marginRight: "16px", whiteSpace: "nowrap" }}>
                  History
                </Typography>
                <div
                  style={{
                    flexGrow: 1,
                    height: "1px",
                    backgroundColor: "#E0E0E0"
                  }}
                />
              </Grid>
              <HistoryFormHotel formik={formik} />
            </Row>
          </>
        )}
      </Box>
    </React.Fragment>
  )
}

export default NormalSteps
